const servicesConfig = {
  myFpo: {
    serviceKey: "myFpo",
    category: "core",
    color: "#54b3d5",
    accessKey: "MY_ORG",
    permissionKey: "fpo",
    label: "My Org",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Manage your organization end-to-end — accounts, members, compliance, reports and more.",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    dashboardPermissions: ["fpoAdminDashboard", "fpoMemberDashboard", "fpoDepartmentDashboard"],
    // Fallback landing for accounts that pass hasServiceAccess but fail the dashboard-permission
    // gate (e.g. viewer-tier roles with no normalPermissions.*Dashboard flag) — see
    // ProtectedRoutes.jsx. About FPO only needs hasServiceAccess (allowedRoles: [] on that
    // route), so it's already reachable for these accounts regardless of the dashboard gate.
    aboutRoute: "/myFpo/about",
    features: [
      "FPC & Membership Management",
      "Purchase, Sales & Stock Tracking",
      "Bank, Cash Book & Ledger",
      "Compliance & Legal Documents",
      "AGM & Board Meeting Records",
      "PDF & Excel Reports",
    ],
  },
  // Product 360 (formerly "My Farm"). The keys stay myfarm / myFarm / MY_FARM so existing
  // permissions, plans and subscriptions keep working; only the name and destination changed.
  myfarm: {
    serviceKey: "myfarm",
    category: "core",
    color: "#a4cf3e",
    accessKey: "MY_FARM",
    permissionKey: "myFarm",
    label: "Product 360",
    icon: "/assets/img/category/product360.avif",
    description: "Everything about each farm product, from seed to export: how to grow, process, pack and sell it, step by step.",
    img: "/assets/img/category/product360.avif",
    isImplemented: true,
    launch: "website", // opens Product 360 (/insights) on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/insights",
    features: [
      "Product Journeys, Seed to Export",
      "Cultivation & Crop Care Guides",
      "Processing & Packaging",
      "Videos & Documents",
      "Market & Export Insights",
    ],
  },
  myproducts: {
    serviceKey: "myproducts",
    category: "core",
    color: "#2e59d7",
    accessKey: "MY_PRODUCTS",
    permissionKey: "products",
    label: "My Products",
    icon: "/assets/img/category/myproductslogo.webp",
    description: "Manage your product catalog, pricing, and inventory with ease.",
    img: "/assets/img/category/myproductslogo.webp",
    isImplemented: false,
    features: [
      "Product Catalog Management",
      "Pricing & Offers",
      "Stock Levels",
      "Category & HSN Codes",
      "Product Reports",
    ],
  },
  mybusiness: {
    serviceKey: "mybusiness",
    category: "core",
    color: "#6739b7",
    accessKey: "MY_BUSINESS",
    permissionKey: "myBusiness",
    label: "My Business",
    icon: "/assets/img/category/business-contract.webp",
    description: "Get a complete view of your business operations, analytics, and growth opportunities.",
    img: "/assets/img/category/business-contract.webp",
    isImplemented: true,
    dashboardPermissions: ["businessAdminDashboard", "businessMemberDashboard", "fpoDepartmentDashboard"],
    // See myFpo's aboutRoute comment above — same fallback mechanism.
    aboutRoute: "/mybusiness/about",
    features: [
      "Business Overview Dashboard",
      "Revenue & Expense Tracking",
      "Partner & Vendor Network",
      "Business Plan Management",
      "Growth Analytics",
    ],
  },
  myexports: {
    serviceKey: "myexports",
    category: "trade",
    color: "#64c5bc",
    accessKey: "MY_EXPORTS",
    permissionKey: "myExports",
    label: "My Exports",
    icon: "/assets/img/category/myexportslogo.webp",
    description: "A step-by-step export learning path, from foundations to payments, and the Export Readiness Score.",
    img: "/assets/img/category/myexportslogo.webp",
    isImplemented: true,
    launch: "website", // opens /exports (the learning path) on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/exports",
    features: [
      "Export Learning Path",
      "Export Documentation",
      "Payments & Protection",
      "Export Readiness Score",
    ],
  },
  myeducation: {
    serviceKey: "myeducation",
    category: "resources",
    color: "#dd8444",
    accessKey: "MY_EDUCATION",
    permissionKey: "myEducation",
    label: "My Education",
    icon: "/assets/img/category/myeducationlogo.webp",
    description: "Educational resources and training",
    img: "/assets/img/category/myeducationlogo.webp",
    isImplemented: true,
    launch: "website", // the FEED WORLD website's My Education (/my-education, Admin → Website → My Education)
    websitePath: "/my-education",
  },
  mymarket: {
    serviceKey: "mymarket",
    category: "trade",
    color: "#dc3545",
    accessKey: "MY_MARKET",
    permissionKey: "myMarket",
    label: "MY Market",
    icon: "/assets/img/category/mymarketlogo.webp",
    description: "Marketplace and trading",
    img: "/assets/img/category/mymarketlogo.webp",
    isImplemented: true,
    launch: "sso", // opens FEED WORLD My Markets (seller dashboard) in a new tab via apis/ssoApi.js
  },
  mytools: {
    serviceKey: "mytools",
    category: "core",
    color: "#f7b31c",
    accessKey: "MY_TOOLS",
    permissionKey: "myTools",
    label: "My Tools",
    icon: "/assets/img/category/mytoolslogo.webp",
    description: "Tools and utilities",
    img: "/assets/img/category/mytoolslogo.webp",
    isImplemented: true,
    launch: "website", // the FEED WORLD website's My Tools (/tools, Admin → Website → My Tools)
    websitePath: "/tools",
  },
  kyj: {
    serviceKey: "kyj",
    category: "resources",
    color: "#16a085",
    accessKey: "KYJ",
    permissionKey: "krushiYevaJayate",
    label: "Krushi Yeva Jayate",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Know your rights and resources",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /kyj on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/kyj",
  },
  yuvakrushi: {
    serviceKey: "yuvakrushi",
    category: "resources",
    color: "#16a34a",
    accessKey: "YUVA_KRUSHI",
    permissionKey: "yuvaKrushi",
    label: "Yuva Krushi",
    icon: "/assets/img/category/yuvakrushi.svg",
    description: "Programme for young farmers",
    img: "/assets/img/category/yuvakrushi.svg",
    isImplemented: true,
    launch: "website", // the FEED WORLD website's Yuva Krushi page and its registration form
    websitePath: "/yuva-krushi",
  },
  safemission: {
    serviceKey: "safemission",
    category: "resources",
    color: "#c0392b",
    accessKey: "SAFE_MISSION",
    permissionKey: "safeMission",
    label: "Safe Mission",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Safety and compliance",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /safe-mission on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/safe-mission",
  },
  loansfinance: {
    serviceKey: "loansfinance",
    category: "finance",
    color: "#2c7a7b",
    accessKey: "LOANS_FINANCE",
    permissionKey: "loans&Finance",
    label: "Loans & Finance",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Financial services and loan schemes",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /loans-finance on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/loans-finance",
  },
  feedcard: {
    serviceKey: "feedcard",
    category: "finance",
    color: "#8e44ad",
    accessKey: "FEED_CARD",
    permissionKey: "feedCard",
    label: "FEED Card",
    icon: "/assets/img/category/cooperativ.webp",
    description: "FEED membership card",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /feed-card on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/feed-card",
  },
  knowyourschemes: {
    serviceKey: "knowyourschemes",
    category: "finance",
    color: "#d68910",
    accessKey: "KNOW_YOUR_SCHEMES",
    permissionKey: "knowYourSchemes",
    label: "Know Your Schemes",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Government schemes and benefits",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /know-your-schemes on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/know-your-schemes",
  },
  tradefairs: {
    serviceKey: "tradefairs",
    category: "trade",
    color: "#34495e",
    accessKey: "TRADE_FAIRS",
    permissionKey: "tradeFairs",
    label: "Trade Fairs",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Trade fairs and exhibitions",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /trade-fairs on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/trade-fairs",
  },
  feedworld: {
    serviceKey: "feedworld",
    category: "trade",
    color: "#1abc9c",
    accessKey: "FEED_WORLD",
    permissionKey: "feedWorld",
    label: "FEED World",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Global trade and international connections",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /feed-world on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/feed-world",
  },
  epm: {
    serviceKey: "epm",
    category: "trade",
    color: "#e91e63",
    accessKey: "EPM",
    permissionKey: "exportPromotionalMeetings",
    label: "Export Promotional Meetings",
    icon: "/assets/img/category/cooperativ.webp",
    description: "Export promotion and meetings",
    img: "/assets/img/category/cooperativ.webp",
    isImplemented: true,
    launch: "website", // opens /epm on the FEED WORLD website, new tab, signed in (apis/ssoApi.js)
    websitePath: "/epm",
  },
  users: {
    serviceKey: "users",
    category: "admin",
    color: "#607d8b",
    accessKey: null,
    // Drives hasServiceAccess("users") — real accessControls.users grant (e.g. an internal
    // department-staff role with users:["R"]), not a systemAdmin-only hardcode. See
    // useVisibleServices.js / routes.js "/users" tree.
    permissionKey: "users",
    label: "Users",
    icon: "/assets/img/category/users.webp",
    description: "Manage system users and permissions",
    img: "/assets/img/category/users.webp",
    isImplemented: true,
  },
  admin: {
    serviceKey: "admin",
    category: "admin",
    color: "#455a64",
    accessKey: null,
    // Drives hasServiceAccess("admin") — real accessControls.roles grant (the same entity key
    // RolePage/AccessibilityRulePage's own in-component usePermission("role") checks already
    // use), not a systemAdmin-only hardcode. See useVisibleServices.js / routes.js "/admin" tree.
    permissionKey: "roles",
    label: "Admin Settings",
    icon: "/assets/img/settingsImg.webp",
    description: "Configure platform roles, permissions, subscription plans and service access controls across all modules",
    img: "/assets/img/settingsImg.webp",
    isImplemented: true,
  },
};

export default servicesConfig;
